import initialState from './initialState';
import { types } from '../actions/authActions';
import { types as accountTypes } from '../actions/accountsActions';

export default function authReducer(state = initialState.auth, action) {
  let newState;
  switch (action.type) {
    case types.SIGN_IN_SUCCESS: {
      newState = Object.assign({}, state);
      newState.signedIn = true;
      return newState;
    }
    case types.SIGN_IN_FAILURE: {
      return state;
    }
    case types.SIGNED_OUT: {
      newState = Object.assign({}, state);
      newState.signedIn = false;
      return newState;
    }
    case accountTypes.DELETE_ACCOUNT_SUCCESS: {
      newState = Object.assign({}, state);
      newState.signedIn = false;
      return newState;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js